import { Select } from "antd";
import { useMemo, useState } from "react";
import { useSearchableOrganizations } from "../../hooks/useSearchableOrganizations";
import { buildSearchableDropdownRender } from "../ui/searchable-select-dropdown";

type FinancialInstituteSelectProps = {
  value?: string;
  onChange?: (value: string) => void;
  status?: "error" | "warning";
  placeholder?: string;
  disabled?: boolean;
};

export function FinancialInstituteSelect({
  value,
  onChange,
  status,
  placeholder = "Select financial institute",
  disabled,
}: FinancialInstituteSelectProps) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const {
    options,
    isLoading,
    isLoadingMore,
    hasMore,
    onSearch,
    onLoadMore,
  } = useSearchableOrganizations({
    merchantType: "MICRO-FINANCE",
    status: "ACTIVE",
  });

  const dropdownRender = useMemo(
    () =>
      buildSearchableDropdownRender({
        searchPlaceholder: "Search financial institutes...",
        onSearch,
        isLoading,
        isLoadingMore,
        hasMore,
        onLoadMore,
        optionCount: options.length,
      }),
    [
      onSearch,
      isLoading,
      isLoadingMore,
      hasMore,
      onLoadMore,
      options.length,
    ],
  );

  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      status={status}
      disabled={disabled}
      loading={isLoading}
      style={{ width: "100%" }}
      options={options}
      showSearch={false}
      filterOption={false}
      dropdownRender={dropdownRender}
      open={dropdownOpen}
      onDropdownVisibleChange={(visible) => {
        setDropdownOpen(visible);
        if (!visible) onSearch("");
      }}
      notFoundContent={isLoading ? "Loading..." : "No institutes found"}
      allowClear
    />
  );
}
